import { getUserSettingsByPlatform } from '../api/usersApi';
import { PATHS } from '../enums/PATHS';
import {
  getComposerWebPreferences,
  setComposerWebPreferences,
} from './localStorage';

export const bootstrapComposerWebPreferences = async () => {
  const adminPath = PATHS.ADMIN_PAGE.path;
  if (window.location.pathname === adminPath || window.location.pathname.startsWith(`${adminPath}/`)) {
    return getComposerWebPreferences();
  }

  try {
    const webSettings = await getUserSettingsByPlatform('web');
    return setComposerWebPreferences({
      ...getComposerWebPreferences(),
      ...webSettings,
    });
  } catch {
    return getComposerWebPreferences();
  }
};
